<small class="debug">{{me}}</small>
<div fxLayout="row" style="position: relative;">
  <button class="rotatedExitIconGlobal" mat-button (click)="onBackScene()">
    <mat-icon matTooltip="{{'general.backToScene' | transloco}}"> logout</mat-icon>
  </button>
  <mat-form-field style="padding-right: 20px">
    <label style="font-size: 0.8em">{{'placeholder.findAddress' | transloco}}</label>
    <input inputrestriction="basic1" #address matInput type="text">
  </mat-form-field>
  <form novalidate autocomplete="off" [formGroup]="contGroup">
    <div>
      <mat-checkbox style="padding-top: 6px" #simMode [checked]="inSimMode === true" (change)="_toggleSimMode()" id="simMode" name="simMode">
        {{'general.simulationMode' | transloco}}
      </mat-checkbox>
      @if (inSimMode) {
        <div>
          <div fxLayout="row" fxLayoutAlign="start start">
            <!--                <label style="padding-bottom: 10px">{{m_simStatus}}</label>-->
            <label (click)="_openSimUrl($event)" style="cursor: pointer; padding-bottom: 10px">{{m_simUrl}}</label>
          </div>
          <div fxLayout="row">
            <button mat-raised-button id="refresh" (click)="_loadStationList()" type="button">
              <mat-icon>refresh</mat-icon>
              {{'general.refresh' | transloco}}
            </button>
            <select formControlName="stations" (change)="_onStationSelected($event)">
              <option>{{'general.selectPlayer' | transloco}}</option>
              @for (station of stations; track station) {
                <option [ngValue]="station">{{station.$.name}}</option>
              }
            </select>
            <select formControlName="postMode">
              <option value="local">Local post</option>
              <option value="remote">Remote post</option>
            </select>
            <select formControlName="port">
              <option value="">select port</option>
              <option value="1024">1024</option>
              <option value="5000">5000</option>
              <option value="9999">9999</option>
              <option value="10500">10500</option>
            </select>
          </div>
        </div>
      }
      <div style="padding-top: 10px; padding-bottom: 10px" fxLayout="row" fxLayoutAlign="start start">
        <label [ngClass]="{'green': m_inRange == true}"> LAT: {{m_simulatedLat}}</label>
        <label style="padding-left: 10px" [ngClass]="{'green': m_inRange == true}"> LNG: {{m_simulatedLng}}</label>
      </div>
    </div>
  </form>

  @if (propsMinimized) {
    <div class="toggle-sidebar">
      <a mat-icon-button (click)="toggleMinimize.emit();">
        <mat-icon style="transform: rotate(180deg)">double_arrow</mat-icon>
      </a>
    </div>
  }
</div>




@if (googleMapApiLoaded) {
  <google-map height="700px"
    width="100%"
    [center]="center"
    [zoom]="zoom"
    (mapClick)="mapClicked($event)"
    (mapMousemove)="move($event)"
    (mapRightclick)="removeLastMarker()">
    @for (m of markerPositions; track m; let i = $index) {
      <map-circle
        [radius]="m.radius"
        [center]="{lat: m.lat, lng: m.lng}"
        (circleClick)="clickedMarker(m, i, $event)">
      </map-circle>
    }
    <!--    <map-marker   -->
    <!--                *ngFor="let markerPosition of markerPositions"-->
    <!--                [position]="markerPosition"-->
    <!--                [options]="{'opacity': markerPosition.color === 'down' ? 0.3 : 1, 'title': markerPosition.label}"-->
    <!--                (mapClick)="openInfoWindow(marker)">-->
  <!--    </map-marker>-->
  <map-info-window></map-info-window>
  <!-- [options]="getOptions($markerPosition)"-->
</google-map>
}

